export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-dispatch/index.js
// module id = 54
// module chunks = 0